/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux'

import BackButton from '../../components/BackButton/BackButton';
import styles from './ViewBookingsDatewisepage.module.css';
import ViewBookingsDatewise from '../../components/ViewBookingsDatewise/ViewBookingsDatewise';

import { CustomTab } from '../../atomicComponents';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';


function ViewBookingsDatewisePage({ product }) {
  const history = useHistory();
  const redirectToProcessPage = () => {
    history.push('/home');
  };


  return (
    <>
      <div className={styles.container} style={{ boxSizing: 'border-box' }}>
            <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToProcessPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div style={{ width: '15%' }}>
            <CustomTab title="View Booking Datewise" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>

            <UserInfoPanel
              userInfo={[{
                "Name :": " Sandesh Bole",
                "SAP ID :": 113399, "BC No :": "113399",
                "LOC :": "Engineering and Research Center"
              }]} />

          </div>
          {/* <div style={{ width: '30%' }} >
          <div className={styles.processTopbar}>
           <div className={styles.Adobtitle}>
            <span className={styles.spanTitle}>Chassis Number</span>
            <span>{chassis}</span>
           </div> 

        
          </div>
          </div>
          <div style={{ width: '30%' }} > 
          <div className={styles.processTopbar}>
           <div className={styles.Adobtitle}>
            <span className={styles.spanTitle}>Material Number</span>
            <span>{materialNo}</span>
           </div> 

        
          </div>
          </div> */}
        </div>

        <ViewBookingsDatewise redirectToProcessPage={redirectToProcessPage} />

      </div>
    </>
  )
}
const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({

});
ViewBookingsDatewisePage.propTypes = {

  product: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(ViewBookingsDatewisePage); 
